import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useLoadingContext } from '../../context/loadingContext';
import { FormProvider, RHFTextField } from '../../components/hook-form';
import Iconify from '../../components/Iconify';
import Page from '../../components/Page';
import { PromotionService } from '../../Services/promotion.service';
import { CKEditorComponent } from '../CKEditor';
import RHFTextArea from '../../components/hook-form/RHFTextArea';

const EventSchema = Yup.object().shape({
  title: Yup.string().required('Tiêu đề không đươc để trống'),
  // promoCode: Yup.string().required('Mã khuyến mãi không được để trống'),
});

export const CreatePromotion = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState('');
  const [image, setImage] = useState();
  const [imageReview, setImageReview] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const [isHotPromotion, setIsHotPromotion] = useState(false);
  const [showBeforePublic, setShowBeforePublic] = useState(false);
  const [dateTime, setDateTime] = React.useState({
    fromDate: '',
    toDate: '',
  });
  const [isLink, setIsLink] = useState(false);
  const { handleStartLoading, handleStopLoading } = useLoadingContext();

  /** React hook form --------------------------------- */
  const defaultValues = {
    title: '',
    promoCode: '',
  };

  const methods = useForm({
    resolver: yupResolver(EventSchema),
    defaultValues,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDateTime((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  /** -------------------------------------------------- */

  const handleOnSubmit = (data) => {
    const form = new FormData();
    if (!content || content.length === 0) {
      enqueueSnackbar('Nội dung không được để trống', { variant: 'error' });
      return;
    }
    form.append('title', data.title);
    form.append('content', content);
    form.append('logo', image);
    form.append('fromDateTime', dateTime.fromDate);
    form.append('toDateTime', dateTime.toDate);
    form.append('showBeforePublic', showBeforePublic);
    form.append('isHotPromotion', isHotPromotion);
    form.append('promoCode', data.promoCode);
    form.append('notes', data.notes ? data.notes : '');
    form.append('isLink', isLink);
    handleStartLoading();
    PromotionService.CreatePromotion(form)
      .then((res) => {
        navigate(`/promotion/view/${res.slug}`, { replace: true, state: '/promotion' });
        enqueueSnackbar('Thêm khuyến mại mới thành công', { variant: 'success' });
      })
      .catch((err) => enqueueSnackbar(err.response.data, { variant: 'error' }))
      .finally(handleStopLoading);
  };

  const handleCancelClick = () => {
    navigate(-1);
  };

  const handleAvatarChange = (e) => {
    const img = e.target.files[0];
    const review = URL.createObjectURL(img);
    setImageReview(review);
    setImage(img);
  };

  return (
    <Page title="Create event">
      <FormProvider methods={methods} onSubmit={handleSubmit(handleOnSubmit)}>
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              Thêm khuyến mãi mới
            </Typography>
            <Stack direction={'row'} spacing={1}>
              <Button
                type="button"
                onClick={handleCancelClick}
                color="error"
                variant="contained"
                startIcon={<Iconify icon="iconoir:cancel" />}
              >
                Cancel
              </Button>
              <Button disabled={isSubmitting} type="submit" variant="contained" startIcon={<Iconify icon="bx:save" />}>
                Save
              </Button>
            </Stack>
          </Stack>
          <Card>
            <CardContent>
              <Grid container spacing={3} direction={{ xs: 'column-reverse', md: 'row' }}>
                <Grid item xs={12} md={8}>
                  <Stack spacing={3}>
                    <RHFTextField name="title" label={'Tiêu đề'} />
                    <RHFTextField name="promoCode" label={'Code'} />
                    <Typography sx={{ mt: '4px !important' }} variant="caption">
                      Voucher sử dụng nhiều lần bắt đầu bằng FBxxx
                    </Typography>
                    <RHFTextArea name="notes" label={'Ghi chú'} />
                    <TextField
                      disabled={isSubmitting}
                      name="fromDate"
                      value={dateTime.fromDate}
                      onChange={handleChange}
                      type={'datetime-local'}
                      size="small"
                      InputLabelProps={{
                        shrink: false,
                      }}
                    />
                    <TextField
                      disabled={isSubmitting}
                      InputProps={{ inputProps: { min: dateTime.fromDate } }}
                      type={'datetime-local'}
                      name="toDate"
                      value={dateTime.toDate}
                      onChange={handleChange}
                      size="small"
                    />
                    <Stack direction="row" spacing={3}>
                      <FormControlLabel
                        control={
                          <Checkbox value={isHotPromotion} onChange={(e) => setIsHotPromotion(e.target.checked)} />
                        }
                        label="Hot Promotion"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox value={showBeforePublic} onChange={(e) => setShowBeforePublic(e.target.checked)} />
                        }
                        label="Hiện thị trước khi đến thời gian"
                      />
                      <FormControlLabel
                        control={<Checkbox value={isLink} onChange={(e) => setIsLink(e.target.checked)} />}
                        label="Chỉ dùng link"
                      />
                    </Stack>
                  </Stack>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    disabled={isSubmitting}
                    sx={{ border: '1px dashed gray' }}
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input onChange={handleAvatarChange} hidden accept="image/*" type="file" />
                    {imageReview ? (
                      <img
                        src={imageReview}
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    ) : (
                      <img
                        src="/static/noimage.jpeg"
                        alt="noimage"
                        width={'300px'}
                        height={'180px'}
                        style={{ objectFit: 'cover' }}
                      />
                    )}
                  </Button>
                  <Typography variant="body2" display="block" sx={{ opacity: '0.6' }}>
                    Kích thước: 520x320
                  </Typography>
                </Grid>
              </Grid>
              <CKEditorComponent
                disabled={isSubmitting}
                placeholder={'Nội dung khuyến mãi'}
                onValueChange={setContent}
                value={content}
              />
            </CardContent>
          </Card>
        </Container>
      </FormProvider>
    </Page>
  );
};
